var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { useS4AMastheadContext } from '../../S4AMastheadProvider';
const UnstyledLink = styled.a `
  text-decoration: none;
  color: inherit;
  border: none;
  display: flex;
  align-items: center;
`;
const UnstyledButton = styled.button `
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  display: flex;
  align-items: center;
`;
export const Link = (_a) => {
    var { openInNewTab = false, children, href, trackingLabel, trackingCategory } = _a, otherProps = __rest(_a, ["openInNewTab", "children", "href", "trackingLabel", "trackingCategory"]);
    const { getLinkProps } = useS4AMastheadContext();
    const props = getLinkProps({
        trackingAttributes: [trackingCategory, trackingLabel, 'click'],
        href: href,
        openInNewTab: openInNewTab,
    });
    if (props.href) {
        return (React.createElement(UnstyledLink, Object.assign({}, props, otherProps), children));
    }
    return (React.createElement(UnstyledButton, Object.assign({}, props, otherProps), children));
};
//# sourceMappingURL=index.js.map